import { type ResourcesConfig } from 'aws-amplify'
import {
  fetchAuthSession as _fetchAuthSession,
  signOut as _signOut,
  type FetchAuthSessionOptions,
  type AuthSession
} from 'aws-amplify/auth'

const env = import.meta.env

export const isMock = env.DEV && env.VITE_LOGIN_USER_USER_POOL_ID

export const config: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: env.VITE_COGNITO_USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: env.VITE_COGNITO_MANAGED_LOGIN_DOMAIN,
          scopes: ['openid'],
          redirectSignIn: [env.VITE_COGNITO_LOGIN_REDIRECT_URL],
          redirectSignOut: [env.VITE_COGNITO_LOGOUT_REDIRECT_URL],
          responseType: 'code'
        }
      }
    }
  }
}

const fetchAuthSessionMock = async (options?: FetchAuthSessionOptions) => {
  options
  return await Promise.resolve({
    tokens: {
      accessToken: env.VITE_LOGIN_USER_USER_POOL_ID
    }
  })
}

export const fetchAuthSession: (
  options?: FetchAuthSessionOptions
) => Promise<AuthSession | null> = isMock
  ? fetchAuthSessionMock
  : async (options?: FetchAuthSessionOptions) => {
      try {
        return await _fetchAuthSession(options)
      } catch (error) {
        console.info('[fetchAuthSession] error', error)
        return null
      }
    }

export const signOut = isMock
  ? async () => await Promise.resolve()
  : async () => {
      // LocalStrage で 保持しているトークンの破棄
      // Cognito が発行する Refresh Token の無効化
      await _signOut({
        global: true
      })
      // Managed Login からのサインアウト
      signOutRedirect()
    }

const signOutRedirect = () => {
  const env = import.meta.env
  const clientId = env.VITE_COGNITO_USER_POOL_CLIENT_ID
  const logoutUri = env.VITE_COGNITO_LOGOUT_REDIRECT_URL
  const cognitoDomain = env.VITE_COGNITO_MANAGED_LOGIN_DOMAIN
  window.location.href = `https://${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`
}
